<template>
  <NxSelect
    :value="localValue"
    :options="listOptions"
    :labelText="labelText ? labelText : 'Produto:'"
    id="selectProdutos"
    placeholder="Selecione o(s) Produto(s)"
    :multiple="multiple"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import ProductRepository from '@/shared/http/repositories/configurations/product.js'
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectProduto',
  mixins: [useReactiveModelMixin('value')],
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    initialValue: {
      type: [Number, null],
      required: false
    },
    labelText: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadProducts()
  },
  methods: {
    onLoadProducts () {
      ProductRepository.GetAll()
        .then((res) => {
          this.listOptions = res.data.content.map((x) => ({
            value: x.id,
            text: x.nome
          }))
          if (this.initialValue !== undefined && this.initialValue !== null) {
            this.localValue = this.listOptions.find(x => x.value === this.initialValue) || null
          }
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Produtos', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectProduto.vue